<template>
<div>
  <!--    Loader-->
  <loading-panel :loading="loading"></loading-panel>

  <div class="row">
    <div class="col-12">
      <card style="overflow-x: scroll" class="no-scrollbar">
        <h4 v-if="changelog_only" class="card-title">Changelog</h4>
        <div v-if="!changelog_only" class="tabs-header d-flex align-items-end mb-3">
          <tab-rail
            v-if="tabRailTabs.length > 0"
            :tabs="tabRailTabs"
            :value="activeTabIndex"
            class="flex-grow-1"
            @input="onTabSelect"
          ></tab-rail>
          <div v-else class="flex-grow-1"></div>
          <template v-if="hasPermissions('roadmap_create')">
            <base-button type="primary" size="sm" class="ml-3 tabs-header__action d-none d-sm-block" v-on:click="createNewTicket()">
              <i class="tim-icons el-icon-plus mr-1"></i> Create ticket
            </base-button>
            <base-button type="primary" size="sm" class="ml-3 tabs-header__action d-block d-sm-none" v-on:click="createNewTicket()">
              <i class="tim-icons el-icon-plus"></i>
            </base-button>
          </template>
        </div>

        <filter-bar
          v-if="!changelog_only"
          :filters="filterSchema"
          :initial-value="filterValues"
          :result-count="activeTabIndex === 4 ? null : totalRows"
          :per-page="activeTabIndex === 4 ? null : perPage"
          :per-page-options="perPageOptions"
          saved-filters-key="roadmap"
          :sort-options="tabSortOptions"
          :sort-value="sort"
          :show-sort-chip="isMobile"
          @update:sort="onSortChange"
          @change="onFiltersChanged"
          @update:perPage="onPerPageChange"
        ></filter-bar>

        <div class="row" v-if="!changelog_only && activeTabIndex !== 4">
          <div class="col">
            <badge type="primary">{{getAvailableVoteCount(total_vote_count)}}/{{available_votes}} votes available</badge>
          </div>
        </div>

        <div v-if="activeTabIndex !== 4 && hasPermissions('roadmap_view')">
          <div class="mt-3" v-if="tickets.length <= 0">
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No tickets match your search.</h4>
            </div>
          </div>

          <div class="row d-sm-block d-none" v-if="tickets.length > 0">
            <div class="col">
              <b-table striped hover :items="tickets"
                       no-local-sorting no-sort-reset
                       :sort-by="sort.key"
                       :sort-desc="sort.dir === 'desc'"
                       @sort-changed="onHeaderSort"
                       :fields="ticketFields">
                <template v-slot:cell(key)="row">
                  <a :href="'/roadmap/ticket?id=' + row.item.id" style="white-space: nowrap">{{row.item.ticket_key}}</a>
                  <div>
                    {{row.item.title}}
                    <i v-if="row.item.watching" class="tim-icons el-icon-view text-info ml-2"></i>
                  </div>
                </template>
                <template v-slot:cell(feature)="row">
                  <badge :style="{'background-color': row.item.feature_badge_color}">{{row.item.feature_name}}</badge>
                </template>
                <template v-slot:cell(ticket_type)="row">
                  {{row.item.ticket_type_name}}
                </template>
                <template v-slot:cell(created)="row">
                  <span style="white-space: nowrap">
                    {{getLocalDateTime(row.item.time_created)}}
                  </span>
                </template>
                <template v-slot:cell(updated)="row">
                  <span style="white-space: nowrap">{{getLocalDateTime(row.item.last_updated || row.item.time_created)}}</span>
                </template>
                <template v-slot:cell(planned)="row">
                  <span v-if="row.item.planned_at" style="white-space: nowrap">{{getLocalDateTime(row.item.planned_at)}}</span>
                  <span v-else>-</span>
                </template>
                <template v-slot:cell(votes)="row">
                  {{row.item.vote_count}}
                </template>
                <template v-slot:cell(watchers)="row">
                  {{row.item.watcher_count}}
                </template>
                <template v-slot:cell(reported_by)="row">
                  <span v-if="!row.item.creator_id">-</span>
                  <span v-else><div style="font-weight: bold">{{row.item.company_name}}</div>
                    <sub class="font-italic">{{row.item.reporter_first_name}} {{row.item.reporter_last_name}}</sub>
                  </span>
                </template>
                <template v-slot:cell(priority)="row">
                   <span style="white-space: nowrap">
                    <i :class="getPriority(row.item.priority).icon" class="mr-1"
                       aria-hidden="true" :style="{'color' : getPriority(row.item.priority).color}"></i>
                        {{ getPriority(row.item.priority).name }}
                  </span>
                </template>
                <template v-slot:cell(status)="row">
                  <badge :style="{'background-color': row.item.label_color}">{{row.item.status_name}}</badge>
                </template>
                <template v-slot:cell(actions)="row">
                  <el-dropdown>
                    <i class="text-primary tim-icons el-icon-more"></i>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <a target="_blank" class="dropdown-item mt-2 mb-2" :href="'/roadmap/ticket?id=' + row.item.id">
                          <i class="tim-icons icon-notes text-info mr-2"></i> Ticket details
                        </a>
                        <a v-if="row.item.status === 5 && activeTabIndex === 1" target="_blank" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'open', 0, $event)" href="#">
                          <i style="color: #42b883" class="tim-icons icon-refresh-02 mr-2"></i> Reopen ticket
                        </a>
                        <a v-if="hasPermissions('roadmap_watch') && !row.item.watching" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'watch', 1, $event)" href="#">
                          <i class="tim-icons el-icon-view text-default mr-2"></i> Watch ticket
                        </a>
                        <a v-if="hasPermissions('roadmap_watch') && row.item.watching" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'watch', 0, $event)" href="#">
                          <i class="tim-icons el-icon-view text-danger mr-2"></i> Stop watching ticket
                        </a>
                        <a v-if="hasPermissions('roadmap_vote') && (activeTabIndex === 0 || activeTabIndex === 1) && row.item.status !== 4 && row.item.status !== 5 && row.item.status !== 9
                        && total_vote_count < available_votes" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'vote', 1, $event)" href="#">
                          <i style="color: #42b883" class="fa fa-thumbs-up mr-2"></i> Vote for this ticket
                        </a>
                        <a v-if="hasPermissions('roadmap_vote') && (activeTabIndex === 0 || activeTabIndex === 1) && row.item.status !== 4 && row.item.status !== 5 && row.item.status !== 9
                        && row.item.my_vote_count > 0" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'vote', 0, $event)" href="#">
                          <i class="fa fa-thumbs-down mr-2 text-danger"></i> Remove vote
                        </a>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </template>
              </b-table>
              <b-pagination v-on:input="getTickets(activeTabIndex, perPage, getOffset())"
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
              ></b-pagination>
            </div>
          </div>

          <div class="row d-sm-none d-block" v-if="tickets.length > 0">
            <div class="col">
              <b-table striped hover :items="tickets"
                       :fields="['tickets']">
                <template #head(tickets)="row">
                  <span>Total results: {{totalRows}}</span>
                </template>
                <template v-slot:cell(tickets)="row">
                  <div class="row">
                    <div class="col">
                      <h4 class="card-title">
                        <a :href="'/roadmap/ticket?id=' + row.item.id">
                        [{{row.item.ticket_key}}]
                        </a>
                        {{row.item.title}}
                        <i v-if="row.item.watching" class="tim-icons el-icon-view text-info ml-2"></i>
                      </h4>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <label>Reported by</label>
                      <p>
                        <span style="font-weight: bold">{{row.item.company_name}}</span>,
                        {{row.item.reporter_first_name}} {{row.item.reporter_last_name}}
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col">
                      <label>Feature</label>
                      <div>
                        <badge :style="{'background-color': row.item.feature_badge_color}">{{row.item.feature_name}}</badge>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col">
                      <label>Ticket type</label>
                      <p>{{row.item.ticket_type_name}}</p>
                    </div>
                    <div class="col">
                      <label>Priority</label>
                      <div>
                        <i :class="getPriority(row.item.priority).icon" class="mr-1"
                           aria-hidden="true" :style="{'color' : getPriority(row.item.priority).color}"></i>
                            {{ getPriority(row.item.priority).name }}
                      </div>
                    </div>
                    <div v-if="activeTabIndex !== 2" class="col">
                      <label>Status</label>
                      <div>
                        <badge :style="{'background-color': row.item.label_color}">{{row.item.status_name}}</badge>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col">
                      <label>Created</label>
                      <p class="text-white">{{getLocalDateTime(row.item.time_created)}}</p>
                    </div>
                    <div class="col">
                      <label>Updated</label>
                      <p class="text-white">{{getLocalDateTime(row.item.last_updated || row.item.time_created)}}</p>
                    </div>
                    <div v-if="activeTabIndex === 2" class="col">
                      <label>Planned since</label>
                      <p class="text-white">{{row.item.planned_at ? getLocalDateTime(row.item.planned_at) : '-'}}</p>
                    </div>
                  </div>

                  <div class="row mt-2">
                    <div class="col">
                      <label>Vote count</label>
                      <p class="text-white">{{row.item.vote_count}}

                        <span v-if="hasPermissions('roadmap_vote') && activeTabIndex !== 2 && ((row.item.status !== 4 && row.item.status !== 5 && row.item.status !== 9
                          && total_vote_count < available_votes) ||
                          (row.item.status !== 4 && row.item.status !== 5 && row.item.status !== 9
                          && row.item.my_vote_count > 0))">
                          <el-dropdown >
                            <i class="text-primary tim-icons el-icon-more ml-2"></i>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <a v-if="hasPermissions('roadmap_vote') && row.item.status !== 4 && row.item.status !== 5 && row.item.status !== 9
                                && total_vote_count < available_votes" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'vote', 1, $event)" href="#">
                                  <i style="color: #42b883" class="fa fa-thumbs-up mr-2"></i> Vote for this ticket
                                </a>
                                <a v-if="hasPermissions('roadmap_vote') && row.item.status !== 4 && row.item.status !== 5 && row.item.status !== 9
                                && row.item.my_vote_count > 0" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'vote', 0, $event)" href="#">
                                  <i class="fa fa-thumbs-down mr-2 text-danger"></i> Remove vote
                                </a>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </span>
                      </p>
                    </div>
                    <div class="col">
                      <label>Watcher count</label>
                      <p class="text-white">{{row.item.watcher_count}}
                        <span v-if="hasPermissions('roadmap_watch')">
                          <el-dropdown>
                            <i class="text-primary tim-icons el-icon-more ml-2"></i>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <a v-if="!row.item.watching" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'watch', 1, $event)" href="#">
                                  <i class="tim-icons el-icon-view text-default mr-2"></i> Watch ticket
                                </a>
                                <a v-if="row.item.watching" class="dropdown-item mt-2 mb-2" @click="modifyTicket(row.item, 'watch', 0, $event)" href="#">
                                  <i class="tim-icons el-icon-view text-danger mr-2"></i> Stop watching ticket
                                </a>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </span>
                      </p>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="mb-3" v-if="activeTabIndex === 4 || changelog_only">
          <a href="/roadmap/legacy">View legacy changelog</a>
        </div>

        <div v-if="activeTabIndex === 4 || changelog_only">
          <div class="mt-3" v-if="tickets.length <= 0">
            <div class="font-icon-detail">
              <span style="font-size: 3em">
                <i class="fas fa-exclamation-triangle"></i>
              </span>
              <h4 class="mt-3">No tickets match your search.</h4>
            </div>
          </div>

          <div class="row" v-for="(w, i) in tickets" :key="'CH' + i">
            <div class="col">
              <h4 class="card-title">{{w.title}}
<!--                <i class="tim-icons icon-minimal-down" style="cursor: pointer;" -->
<!--                   v-on:click="w.collapse = !w.collapse"></i>-->
              </h4>
              <div  class="row" v-for="(tt, i) in w.ticketsByType" :key="'TTCH' + i" >
                <div class="col" >
                  <p :style="{'color': tt.ticket_type_label_color}" class="text-uppercase">{{ tt.type }}</p>
                  <ul>
                    <li v-for="(ti, i) in tt.tickets" :key="'TICKS' + i">
                      <badge :style="{'background-color': ti.feature_badge_color}">{{ti.feature_name}}</badge>&nbsp;
                      {{ti.title}}
                      <router-link
                        v-if="!changelog_only"
                        :to="'/roadmap/ticket/?id=' + ti.id"
                        custom
                        v-slot="{ href }"
                      >
                        <a :href="href" target="_blank" rel="noopener">
                          <i class="tim-icons el-icon-top-right"></i>
                        </a>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </card>
    </div>

    <base-drawer :show="modals.new_ticket" title="Create a ticket" width="720px" @close="dismissTicketDrawer">
      <drawer-section title="Ticket" icon="icon-notes">
        <info-hint variant="primary" icon="icon-bulb-63">
          Tickets with clear answers to the questions below get picked up faster. Include exact names, dates, and what you saw on screen.
        </info-hint>
        <base-input required label="Ticket type" :error="errs.ticket_type">
          <el-select
            v-model="ticket.ticket_type"
            class="select-primary"
            value-key="id"
            placeholder="Ticket type">
            <el-option
              v-for="(t, index) in ticket_types"
              class="select-primary"
              :label="t.name"
              :value="{id: t.id, name: t.name}"
              :key="'T' + index"
            ></el-option>
          </el-select>
        </base-input>
        <base-input required label="Feature" :error="errs.feature">
          <el-select
            v-model="ticket.feature"
            class="select-primary"
            value-key="id"
            placeholder="Feature">
            <el-option
              v-for="(f, index) in features"
              class="select-primary"
              :label="f.name"
              :value="{id: f.id, name: f.name}"
              :key="'F' + index"
            ></el-option>
          </el-select>
        </base-input>
        <base-input label="Ticket summary" :error="errs.summary" placeholder="Summary" required v-model="ticket.title"></base-input>
      </drawer-section>

      <drawer-section v-if="ticketQuestions.length > 0" title="Details" icon="icon-bullet-list-67">
        <div
          v-for="(question, i) in ticketQuestions"
          :key="ticket.ticket_type.name + '-' + i"
          class="form-group"
          :class="{ 'has-danger': ticketAnswerErrors[i] }"
        >
          <label>{{ question }} *</label>
          <rich-text-editor
            :value="ticketAnswers[i]"
            toolbar="minimal"
            :allow-images="false"
            :height="90"
            placeholder="Your answer"
            :dark="isDarkMode"
            @input="onTicketAnswerInput(i, $event)"
          />
          <label v-if="ticketAnswerErrors[i]" class="error">{{ ticketAnswerErrors[i] }}</label>
        </div>
      </drawer-section>

      <drawer-section title="Anything else" icon="icon-pencil">
        <rich-text-editor
          ref="descriptionEditor"
          v-model="descriptionHtml"
          placeholder="Screenshots, links, or anything the questions did not cover (optional)"
          :height="120"
          :dark="isDarkMode"
          toolbar="minimal"
        />
      </drawer-section>

      <template #footer>
        <div class="footer-actions">
          <base-button type="secondary" size="sm" @click="onDiscardTicketClick">Discard</base-button>
          <base-button type="primary" size="sm" @click="createTicket()">Create</base-button>
        </div>
      </template>
    </base-drawer>

    <base-alert-dialog
      :show="showProfileNameAlert"
      title="Profile name required"
      message="Please add your first and last name to your profile before creating a ticket."
      variant="danger"
      confirm-text="OK"
      @confirm="showProfileNameAlert = false"
      @cancel="showProfileNameAlert = false"
    />

    <base-alert-dialog
      :show="showDiscardTicketDialog"
      title="Discard this ticket?"
      message="Everything you wrote in this ticket will be deleted."
      variant="danger"
      show-cancel
      confirm-text="Discard"
      cancel-text="Keep editing"
      confirm-variant="danger"
      @confirm="confirmDiscardTicket"
      @cancel="showDiscardTicketDialog = false"
    />

    <base-alert-dialog
      :show="alert.show"
      :title="alert.title"
      :message="alert.message"
      :variant="alert.variant"
      confirm-text="OK"
      @confirm="alert.show = false"
      @cancel="alert.show = false"
    />
  </div>
</div>
</template>

<script>
import {Badge} from 'src/components'
import {BPagination, BTable} from "bootstrap-vue";
import {Auth} from "aws-amplify";
import {API_LOCATION} from "@/api-config";
import axios from "axios";
import {formatGroupDate, formatGroupTime, date as formatWallDate} from "@/plugins/dates";
import {Dropdown, DropdownItem, DropdownMenu} from "element-ui";
import _ from "lodash";
import RichTextEditor from "@/components/RichTextEditor";
import TabRail from "@/components/TabRail.vue";
import { plainTextToHtml, isEmptyHtml } from '@/util/richText'
import { draftKeyFromStorage, draftFingerprint, EMPTY_DRAFT_FINGERPRINT, readDraft, writeDraft, removeDraft, hasTypedContent } from '@/util/roadmapTicketDraft'

// Required questions per ticket type, keyed by work_ticket_types.name.
// Answers are assembled into the description HTML on submit; the lambda
// contract (title, description, type_id, feature_id) does not change.
const TICKET_QUESTIONS = {
  'Bug': [
    'What did you do, step by step?',
    'What did you expect to happen?',
    'What happened instead?',
    'Which page did this happen on?'
  ],
  'Enhancement': [
    'What are you trying to do?',
    'How do you do it today, and what makes it hard?',
    'What would you like to change?'
  ],
  'New feature': [
    'What problem would this solve for you?',
    'Who would use it and how often?',
    'How do you handle this today?'
  ],
  'Support': [
    'What do you need help with?',
    'What have you already tried?',
    'Which page is this about?'
  ]
}

export default {
  name: "Changelog",
  components: {
    Badge,
    BTable,
    BPagination,
    RichTextEditor,
    TabRail,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
  },
  computed: {
    ticketQuestions() {
      const name = this.ticket.ticket_type && this.ticket.ticket_type.name
      return TICKET_QUESTIONS[name] || []
    },
    categories() {
      if(this.hasPermissions('roadmap_view')){
        return [{name: 'Open tickets', short_name: 'Open', icon: 'tim-icons icon-gift-2', active: true},
          {name: 'My tickets', short_name: 'My tickets', icon: 'tim-icons icon-settings-gear-63', active: false},
          {name: 'Planned', short_name: 'Planned', icon: 'tim-icons icon-settings-gear-63', active: false},
          {name: 'Work in progress', short_name: 'In progress', icon: 'tim-icons icon-settings-gear-63', active: false},
          {name: 'Changelog', short_name: 'Changelog', icon: 'tim-icons icon-settings-gear-63', active: false},
        ];
      } else {
        return [];
      }

    },
    // Desktop table columns. Planned since only shows on the Planned tab (2), which in
    // turn drops Status since every row there is Planned.
    ticketFields() {
      const fields = [
        {key: 'key', label: 'Ticket', sortable: true}, {key: 'ticket_type', sortable: true}, {key: 'feature', sortable: true},
        {key: 'reported_by', sortable: true}, {key: 'created', sortable: true}, {key: 'updated', sortable: true},
        {key: 'planned', label: 'Planned since', sortable: true}, {key: 'priority', sortable: true}, 'status',
        {key: 'votes', sortable: true}, {key: 'watchers', sortable: true}, 'actions'
      ]
      return this.activeTabIndex === 2
        ? fields.filter(f => f !== 'status')
        : fields.filter(f => f.key !== 'planned')
    },
    // Sort chip options for the active tab: none on Changelog, Planned since only on Planned.
    tabSortOptions() {
      if (this.activeTabIndex === 4) return []
      return this.activeTabIndex === 2 ? this.sortOptions : this.sortOptions.filter(o => o.key !== 'planned')
    },
    // TabRail shape: full label on desktop, short label below md.
    tabRailTabs() {
      return this.categories.map(c => ({ name: c.name, shortName: c.short_name }));
    },
    // Schema for the shared <filter-bar>. Select options for ticket type, feature and
    // status come from the fetch response; priority is a static local list.
    filterSchema() {
      const defs = [
        { key: 'key', type: 'text', label: 'Key', placeholder: 'Key', operatorLabel: 'contains', primary: true },
        { key: 'summary', type: 'text', label: 'Summary', placeholder: 'Summary', operatorLabel: 'contains', primary: true },
        { key: 'ticket_type', type: 'select', label: 'Ticket type', primary: true,
          options: (Array.isArray(this.ticket_types) ? this.ticket_types : []).map(t => ({ label: t.name, value: t.id })) },
        { key: 'feature', type: 'select', label: 'Feature', primary: true,
          options: (Array.isArray(this.features) ? this.features : []).map(f => ({ label: f.name, value: f.id })) },
        { key: 'reported_by', type: 'text', label: 'Reported by', placeholder: 'Reported by', operatorLabel: 'contains', primary: true },
        { key: 'created', type: 'daterange', label: 'Created', primary: true },
        { key: 'priority', type: 'select', label: 'Priority', primary: true,
          options: (Array.isArray(this.priorities) ? this.priorities : []).map(p => ({ label: p.name, value: p.id })) },
        { key: 'status', type: 'select', label: 'Status', primary: true,
          options: (Array.isArray(this.statuses) ? this.statuses : []).map(s => ({ label: s.name, value: s.id })) },
        { key: 'vote_count', type: 'numberrange', label: 'Votes', primary: true },
        { key: 'company_vote_only', type: 'toggle', label: "My company's votes only", primary: false },
        { key: 'watcher_count', type: 'numberrange', label: 'Watchers', primary: true },
      ]
      // The Changelog tab only ever exposed these four filters; keep that
      // visibility so the tab matches its prior behavior.
      if (this.activeTabIndex === 4) {
        const changelogKeys = ['key', 'summary', 'ticket_type', 'feature']
        return defs.filter(f => changelogKeys.includes(f.key))
      }
      return defs
    }
  },
  data(){
    return {
      loading: false,
      date_format_cal: '',
      day_of_week: '',
      changelog_only: false,
      total_vote_count: 0,
      // SavedViewsMenu (FilterBar) drives the first fetch via its initial @change; this guards it.
      didInitialFetch: false,
      perPageOptions: [5, 10, 25, 50],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      // Server-side sort for list tabs; key 'key' ascending matches the lambda default.
      sort: { key: 'key', dir: 'asc' },
      // Desktop sorts from the table headers; the FilterBar sort chip only shows on
      // mobile, where the card list has no headers (same 576px split as d-sm-*).
      isMobile: false,
      sortOptions: [
        { key: 'key', label: 'Key' },
        { key: 'created', label: 'Created' },
        { key: 'updated', label: 'Updated' },
        { key: 'planned', label: 'Planned since' },
        { key: 'ticket_type', label: 'Ticket type' },
        { key: 'feature', label: 'Feature' },
        { key: 'reported_by', label: 'Reported by' },
        { key: 'priority', label: 'Priority' },
        { key: 'votes', label: 'Votes' },
        { key: 'watchers', label: 'Watchers' },
      ],
      date_format: JSON.parse(localStorage.getItem('group')).date_format,
      time_format: JSON.parse(localStorage.getItem('group')).time_format,
      first_day_of_week: JSON.parse(localStorage.getItem('group')).first_day_of_week,
      descriptionHtml: '',
      // Answers to the selected ticket type's required questions, index aligned
      // with ticketQuestions. Reset whenever the type changes.
      ticketAnswers: [],
      ticketAnswerErrors: [],
      showProfileNameAlert: false,
      // OTC-3156: Discard asks first when the draft holds typed content.
      showDiscardTicketDialog: false,
      // Set while restoring a draft so the type watcher keeps the restored answers.
      skipNextTypeReset: false,
      // Read at drawer open, not cached: the navbar theme toggle does not
      // navigate, and BaseDrawer remounts the editors on every open.
      isDarkMode: true,
      // Generic alert for modifyTicket outcomes (vote, watch, reopen, 500).
      alert: { show: false, title: '', message: '', variant: 'success' },
      modals: { new_ticket: false},
      activeTabIndex: 0,
      errs: {
        ticket_type: '',
        feature: '',
        summary: ''
      },
      ticket_types: [],
      statuses: [],
      features: [],
      priorities: [
        {id: 1, name: "Highest", icon: 'fa fa-angle-double-up', color: '#ec250d'},
        {id: 2, name: "High", icon: 'fa fa-angle-up', color: '#ec250d'},
        {id: 3, name: "Medium", icon: 'tim-icons icon-simple-delete', color: '#ff8d72'},
        {id: 4, name: "Low", icon: 'fa fa-angle-down', color: '#1d8cf8'},
        {id: 5, name: "Lowest", icon: 'fa fa-angle-double-down', color: '#1d8cf8'},
      ],
      ticket: {},
      tickets: [],
      available_votes: 5,
      // Flat filter values for the shared <filter-bar>. Seeded from the URL in mounted;
      // saved-views precedence is resolved by FilterBar. Select values are ids.
      filterValues: {
        key: '',
        summary: '',
        ticket_type: '',
        feature: '',
        reported_by: '',
        created: { mode: 'range', days: '', from: '', to: '' },
        priority: '',
        status: '',
        vote_count: { from: '', to: '' },
        company_vote_only: false,
        watcher_count: { from: '', to: '' }
      }
    }
  },
  watch: {
    // Switching type swaps the question list, so stale answers are dropped.
    'ticket.ticket_type'(newType, oldType) {
      if (this.skipNextTypeReset) {
        this.skipNextTypeReset = false
        return
      }
      const newName = newType && newType.name
      const oldName = oldType && oldType.name
      if (newName === oldName) return
      this.ticketAnswers = this.ticketQuestions.map(() => '')
      this.ticketAnswerErrors = this.ticketQuestions.map(() => '')
    },
    'modals.new_ticket'(open) {
      if (open) {
        document.addEventListener('keydown', this._onEscKey)
      } else {
        document.removeEventListener('keydown', this._onEscKey)
      }
    },
    // OTC-3156: every form change schedules a draft save.
    ticket: { deep: true, handler() { this.scheduleDraftSave() } },
    ticketAnswers() { this.scheduleDraftSave() },
    descriptionHtml() { this.scheduleDraftSave() }
  },
  created() {
    this._mobileMql = window.matchMedia('(max-width: 575.98px)')
    this._onMobileMql = () => { this.isMobile = this._mobileMql.matches }
    this._onMobileMql()
    this._mobileMql.addEventListener('change', this._onMobileMql)
    this._onEscKey = (e) => {
      // The alert dialog handles its own ESC; do not close the drawer under it.
      if (e.key === 'Escape' && this.modals.new_ticket && !this.showProfileNameAlert) {
        this.dismissTicketDrawer()
      }
    }
    this._draftKey = draftKeyFromStorage()
    // The form as this tab last loaded, saved or discarded it. Saves skip when the
    // form still matches, so an untouched tab never overwrites or removes a draft
    // another tab saved.
    this._draftBaseline = EMPTY_DRAFT_FINGERPRINT
    this._debouncedDraftSave = _.debounce(() => this.saveDraftNow(), 500)
    this._onBeforeUnload = () => this.saveDraftNow()
    window.addEventListener('beforeunload', this._onBeforeUnload)
  },
  beforeDestroy() {
    // The editor ref still exists here, so a screenshot added without typing is kept.
    this.saveDraftNow()
    window.removeEventListener('beforeunload', this._onBeforeUnload)
    document.removeEventListener('keydown', this._onEscKey)
    this._mobileMql.removeEventListener('change', this._onMobileMql)
  },
  methods: {
    hasPermissions(scope){
      let permissions = JSON.parse(localStorage.getItem('permissions'))
      const matchFound = permissions.some(element => element === scope);
      return matchFound
    },
    // FilterBar change: apply new values and (re)fetch. The first change is
    // FilterBar's initial saved-views resolution and drives the first load.
    onFiltersChanged(values){
      this.filterValues = {
        key: values.key || '',
        summary: values.summary || '',
        ticket_type: values.ticket_type || '',
        feature: values.feature || '',
        reported_by: values.reported_by || '',
        created: { ...(values.created || { mode: 'range', days: '', from: '', to: '' }) },
        priority: values.priority || '',
        status: values.status || '',
        vote_count: { ...(values.vote_count || { from: '', to: '' }) },
        company_vote_only: !!values.company_vote_only,
        watcher_count: { ...(values.watcher_count || { from: '', to: '' }) }
      }
      if(!this.didInitialFetch){
        this.didInitialFetch = true
        // Initial load preserves the URL page (currentPage seeded in mounted).
        this.getTickets(this.activeTabIndex, this.perPage, this.getOffset())
      } else {
        // Applying a filter/view lands on page 1; reset BEFORE computing the offset
        // (a stale/NaN page would build a negative/out-of-range offset).
        this.currentPage = 1
        this.getTickets(this.activeTabIndex, this.perPage, this.getOffset(), 0, 'filter')
      }
    },
    // b-table header click (desktop); same fetch path as the FilterBar chip
    onHeaderSort(ctx){
      this.onSortChange({ key: ctx.sortBy || 'key', dir: ctx.sortDesc ? 'desc' : 'asc' })
    },
    onSortChange(value){
      this.sort = value
      // Before the first fetch (saved view restore) just record it; the initial fetch uses it.
      if(!this.didInitialFetch) return
      this.currentPage = 1
      this.getTickets(this.activeTabIndex, this.perPage, 0, 0, 'filter')
    },
    onPerPageChange(n){
      this.perPage = n
      this.currentPage = 1
      this.getTickets(this.activeTabIndex, this.perPage, this.getOffset(), 0, 'filter')
    },
    // Derive plain yyyy-MM-dd from/to from the current created filter value,
    // matching the created_from/created_to params the backend expects.
    computeCreatedRange(){
      const d = this.filterValues.created || {}
      let from = ''
      let to = ''
      if(d.mode === 'days' && d.days !== '' && d.days != null){
        const today = new Date()
        const start = new Date()
        start.setDate(start.getDate() - Number(d.days))
        from = start.getFullYear() + '-' + ('0' + (start.getMonth() + 1)).slice(-2) + '-' + ('0' + start.getDate()).slice(-2)
        to = today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2)
      } else {
        from = d.from || ''
        to = d.to || ''
      }
      return { from, to }
    },
    getAvailableVoteCount(count){
      return (this.available_votes - count) >= 0 ? (this.available_votes - count) : 0
    },
    async modifyTicket(item, action, modifier, event){
      event.preventDefault()
      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/work/' + item.id

      let data = {
        action: action,
        modifier: modifier
      }

      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          let text = 'You are now watching this ticket'
          if(action === 'vote' && modifier === 1){
            text = 'You added a vote to the ticket'
          } else if(action === 'vote' && modifier === 0){
            text = 'You removed a vote from the ticket'
          }  else if(action === 'watch' && modifier === 0){
            text = 'You stopped watching this ticket'
          } else if(action === 'open'){
            text = 'The ticket has been reopened'
          }
          this.showAlert('Success', text, 'success')
          this.getTickets(this.activeTabIndex, this.perPage, this.getOffset())
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          } if(err.response.status == 500){
            this.showAlert('Error', String(err.response.data), 'danger')
          }
        })
    },
    getLocalDateTime(d){
      if(!d) return ''
      const date = formatGroupDate(d, { dayOfWeek: false })
      const time = formatGroupTime(d)
      if(!date && !time) return ''
      return `${date}, ${time}`
    },
    getPriority(priority){
      let p = _.find(this.priorities, {id: priority})
      return p
    },
    validateTicket(){
      let errors = 0

      if(!this.ticket.title){
        this.errs.summary = "Summary cannot be empty"
        errors++
      } else {
        this.errs.summary = ''
      }
      if(!this.ticket.feature){
        this.errs.feature = "Feature cannot be empty"
        errors++
      } else {
        this.errs.feature = ''
      }
      if(!this.ticket.ticket_type){
        this.errs.ticket_type = "Ticket type cannot be empty"
        errors++
      } else {
        this.errs.ticket_type = ''
      }

      this.ticketAnswerErrors = this.ticketQuestions.map((q, i) => {
        if (isEmptyHtml(this.ticketAnswers[i] || '')) {
          errors++
          return 'Please answer this question'
        }
        return ''
      })

      return errors > 0 ? false : true
    },
    clearTicket(){
      // Match the initial data() state. Seeding ticket_type with an id but no
      // name made el-select (value-key="id") show a type as selected while the
      // name-keyed ticketQuestions lookup returned nothing.
      this.ticket = {}
      this.descriptionHtml = ''
      this.ticketAnswers = []
      this.ticketAnswerErrors = []
      if (this.$refs.descriptionEditor) this.$refs.descriptionEditor.clear()
    },
    createNewTicket(){
      this.isDarkMode = !document.body.classList.contains('white-content')
      this.modals.new_ticket = true
    },
    // OTC-3156: the form as a draft object. The description is read from the
    // editor because an inserted screenshot does not emit input until the next keystroke.
    currentDraft(){
      const description = this.$refs.descriptionEditor ? this.$refs.descriptionEditor.getContent() : this.descriptionHtml
      return {
        ticket_type: this.ticket.ticket_type || null,
        feature: this.ticket.feature || null,
        title: this.ticket.title || '',
        answers: this.ticketAnswers.slice(),
        description: description || ''
      }
    },
    scheduleDraftSave(){
      if (this._debouncedDraftSave) this._debouncedDraftSave()
    },
    // Writes only for the user who loaded the page (sign out clears localStorage
    // before its redirect tears this page down) and only when this tab changed
    // the form since it last loaded, saved or discarded it.
    saveDraftNow(){
      if (this._debouncedDraftSave) this._debouncedDraftSave.cancel()
      const key = draftKeyFromStorage()
      if (!key || key !== this._draftKey) return
      const draft = this.currentDraft()
      const fingerprint = draftFingerprint(draft)
      if (fingerprint === this._draftBaseline) return
      writeDraft(key, draft)
      this._draftBaseline = fingerprint
    },
    // A restored type or feature may have been renamed or removed since it was
    // saved. Match by id against the loaded lists: a new name resets the answers
    // through the type watcher, and a removed one clears the selection.
    reconcileDraftSelections(){
      const reconcile = (field, list) => {
        const current = this.ticket[field]
        if (!current || !Array.isArray(list) || list.length === 0) return
        const live = list.find(item => String(item.id) === String(current.id))
        if (!live) {
          this.$delete(this.ticket, field)
        } else if (live.name !== current.name) {
          this.$set(this.ticket, field, { id: live.id, name: live.name })
        }
      }
      reconcile('ticket_type', this.ticket_types)
      reconcile('feature', this.features)
    },
    restoreDraft(){
      const draft = readDraft(this._draftKey)
      if (!draft) return
      const questions = draft.ticket_type ? (TICKET_QUESTIONS[draft.ticket_type.name] || []) : []
      if (draft.ticket_type) this.skipNextTypeReset = true
      const ticket = {}
      if (draft.ticket_type) ticket.ticket_type = draft.ticket_type
      if (draft.feature) ticket.feature = draft.feature
      if (draft.title) ticket.title = draft.title
      this.ticket = ticket
      this.ticketAnswers = draft.answers.length === questions.length ? draft.answers.slice() : questions.map(() => '')
      this.ticketAnswerErrors = questions.map(() => '')
      this.descriptionHtml = draft.description
      this._draftBaseline = draftFingerprint(this.currentDraft())
    },
    // X, overlay click and ESC: close and keep everything. Closing mid-upload
    // would destroy the editor before the image lands, so it waits.
    dismissTicketDrawer(){
      if (this.$refs.descriptionEditor && this.$refs.descriptionEditor.uploading) {
        this.$notify({ type: 'warning', message: 'Wait for the image to finish uploading before closing.', icon: 'tim-icons icon-alert-circle-exc' })
        return
      }
      if (this.$refs.descriptionEditor) this.descriptionHtml = this.$refs.descriptionEditor.getContent()
      this.saveDraftNow()
      this.modals.new_ticket = false
      this.errs = { ticket_type: '', feature: '', summary: '' }
      this.ticketAnswerErrors = this.ticketQuestions.map(() => '')
    },
    // Close, clear the form and drop the stored draft (Discard, successful Create).
    discardTicketDraft(){
      this.modals.new_ticket = false
      this.errs = { ticket_type: '', feature: '', summary: '' }
      this.clearTicket()
      if (this._debouncedDraftSave) this._debouncedDraftSave.cancel()
      const key = draftKeyFromStorage()
      if (key && key === this._draftKey) removeDraft(key)
      this._draftBaseline = EMPTY_DRAFT_FINGERPRINT
    },
    onDiscardTicketClick(){
      if (hasTypedContent(this.currentDraft())) {
        this.showDiscardTicketDialog = true
        return
      }
      this.discardTicketDraft()
    },
    // Hide the dialog first, then the drawer, or the page stays scroll-locked.
    async confirmDiscardTicket(){
      this.showDiscardTicketDialog = false
      await this.$nextTick()
      this.discardTicketDraft()
    },
    // base-input and the question wrappers both flag errors with .has-danger,
    // so the first one in document order is the topmost failing field.
    scrollToFirstTicketError(){
      this.$nextTick(() => {
        const el = this.$el.querySelector('.base-drawer__body .has-danger')
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    },
    showAlert(title, message, variant){
      this.alert = { show: true, title: title, message: message, variant: variant }
    },
    onTicketAnswerInput(index, value){
      this.$set(this.ticketAnswers, index, value)
      if (this.ticketAnswerErrors[index]) {
        this.$set(this.ticketAnswerErrors, index, '')
      }
    },
    // TabRail emits the index only; switchTab resets to page 1, so the fetch
    // starts at offset 0.
    onTabSelect(index){
      this.switchTab(index, this.perPage, 0)
    },
    // Planned since only exists on the Planned tab; don't keep sorting by a hidden column.
    dropHiddenSort(tabIndex){
      if (this.sort.key === 'planned' && tabIndex !== 2) this.sort = { key: 'key', dir: 'asc' }
    },
    switchTab(index, count, offset, init){
      this.dropHiddenSort(index)
      this.activeTabIndex = index
      for(let n in this.categories){
        this.categories[n].active = false
      }
      this.categories[index].active = true

      this.currentPage = 1
      this.getTickets(this.activeTabIndex, count, offset, init)
    },
    getAuthToken() {
      return new Promise ( function(resolve) {
        Auth.currentSession()
          .then(data =>{
            resolve(data.idToken.jwtToken)
          })
          .catch(err => console.log(err))
      })
    },
    groupTicketsByWeek(tickets) {
      const dateFormat = this.date_format || 'MM/DD/YYYY'
      function getWeekKeyAndTitle(dateString) {
        if (dateString) {
          const date = new Date(dateString);

          // Ensure the date is in UTC to avoid timezone inconsistencies
          const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

          // Get the weekday (0 = Sunday, 6 = Saturday)
          const dayOfWeek = utcDate.getUTCDay();
          const diffToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Adjust to Monday
          utcDate.setUTCDate(utcDate.getUTCDate() + diffToMonday); // Move to Monday

          // Use the year from Monday of the week (handles year transitions correctly)
          const year = utcDate.getUTCFullYear();

          // Compute the ISO week number based on Monday's year
          const startOfYear = new Date(Date.UTC(year, 0, 1));
          const daysDifference = Math.floor((utcDate - startOfYear) / (1000 * 60 * 60 * 24));
          const weekNumber = Math.ceil((daysDifference + startOfYear.getUTCDay() + 1) / 7);

          // Monday of the week as a wall date in the group's date format (no timezone shift)
          const title = 'Week of ' + formatWallDate(utcDate.toISOString().slice(0, 10), dateFormat);

          return {
            weekKey: `${year}-W${String(weekNumber).padStart(2, "0")}`,
            title
          };
        }
        return null;
      }
      const grouped = tickets.reduce((result, ticket) => {
        const keyAndTitle = getWeekKeyAndTitle(ticket.time_resolved);
        if (keyAndTitle) {
          const { weekKey, title } = keyAndTitle;
          if (!result[weekKey]) {
            result[weekKey] = { title, tickets: [] };
          }
          result[weekKey].tickets.push(ticket);
        }
        return result;
      }, {});

      // Convert to an array and sort by weekKey in descending order
      return Object.entries(grouped)
        .map(([weekKey, data]) => ({
          weekKey,
          title: data.title,
          ticketsByType: Object.entries(
            data.tickets.reduce((types, ticket) => {
              const type = ticket.ticket_type_name || "Unknown";
              if (!types[type]) {
                types[type] = { tickets: [], ticket_type_label_color: ticket.ticket_type_label_color || null };
              }
              types[type].tickets.push(ticket);
              return types;
            }, {})
          ).map(([type, { tickets, ticket_type_label_color }]) => ({
            type,
            ticket_type_label_color,
            tickets
          }))
        }))
        .sort((a, b) => b.weekKey.localeCompare(a.weekKey));
    },
    async getTickets(tab, count, offset, init, source){
      if(source === 'filter'){
        this.currentPage = 1
      }
      const f = this.filterValues
      const votes = f.vote_count || {}
      const watchers = f.watcher_count || {}
      const created = this.computeCreatedRange()
      const feature = f.feature || ''
      const ticket_type = f.ticket_type || ''
      const status = f.status || ''
      const priority = f.priority || ''

      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/work?tab=' + tab +
        "&summary=" + encodeURIComponent(f.summary)
        +"&key=" + encodeURIComponent(f.key)
        +"&reported_by=" + encodeURIComponent(f.reported_by)
        +"&feature=" + encodeURIComponent(feature)
        +"&ticket_type=" + encodeURIComponent(ticket_type)
        +"&status=" + encodeURIComponent(status)
        +"&priority=" + encodeURIComponent(priority)
        +"&vote_count_to=" + encodeURIComponent(votes.to || '')
        +"&vote_count_from=" + encodeURIComponent(votes.from || '')
        +"&company_vote_only=" + encodeURIComponent(f.company_vote_only)
        +"&created_to=" + encodeURIComponent(created.to)
        +"&created_from=" + encodeURIComponent(created.from)
        +"&watcher_count_to=" + encodeURIComponent(watchers.to || '')
        +"&watcher_count_from=" + encodeURIComponent(watchers.from || '')
        + '&sort=' + encodeURIComponent(this.sort.key) + '&dir=' + encodeURIComponent(this.sort.dir)
        + '&count=' + count + '&offset=' + offset

      axios.get(url, config)
        .then(response => {
          this.loading = false
          this.ticket_types = response.data.ticket_types
          this.features = response.data.features
          this.reconcileDraftSelections()
          this.tickets = response.data.tickets
          if(this.activeTabIndex === 4 || this.changelog_only){
            this.tickets = this.groupTicketsByWeek(this.tickets)
          }
          this.total_vote_count = response.data.total_vote_count
          this.statuses = response.data.statuses
          this.totalRows = response.data.total_rows

          if(!this.changelog_only){
            this.addQueryParameters()
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response.status == 401){
            this.$router.push('/forbidden')
          }
        })
    },
    async createTicket(){
      if(!this.validateTicket()){
        this.scrollToFirstTicketError()
        return
      }

      if(JSON.parse(localStorage.getItem('profile')).first_name === '' ||
        !JSON.parse(localStorage.getItem('profile')).first_name ||
        JSON.parse(localStorage.getItem('profile')).last_name === '' ||
        !JSON.parse(localStorage.getItem('profile')).last_name){
        this.showProfileNameAlert = true
        return
      }

      this.loading = true
      let token = await this.getAuthToken()
      let config = { headers: { Authorization: token } }
      let companyId = localStorage.getItem('companyId')
      let companyGroupId = JSON.parse(localStorage.getItem('group')).id
      let url = API_LOCATION + 'companies/' + companyId + '/groups/' + companyGroupId + '/work'

      let data = {
        title: this.ticket.title,
        description: this.buildTicketDescription(),
        type_id: this.ticket.ticket_type.id,
        feature_id: this.ticket.feature.id
      }

      axios.post(url, data, config)
        .then(response => {
          this.loading = false
          this.discardTicketDraft()
          this.getTickets(this.activeTabIndex, this.perPage, this.getOffset())
        })
        .catch(err => {
          this.loading = false
          console.log(err)
          if(err.response && err.response.status == 401){
            this.$router.push('/forbidden')
            return
          }
          const message = err.response && err.response.data
            ? String(err.response.data)
            : 'The ticket could not be created. Please try again.'
          this.showAlert('Error', message, 'danger')
        })
    },
    // One HTML string for the lambda: each question as a bold heading over its
    // answer, then the optional free-text section. Answers are editor HTML,
    // already sanitized by rich-text-editor on input.
    buildTicketDescription(){
      const parts = this.ticketQuestions.map((question, i) => {
        return '<p><strong>' + plainTextToHtml(question).replace(/^<p>|<\/p>$/g, '') + '</strong></p>'
          + (this.ticketAnswers[i] || '')
      })
      const extra = this.getEditorContent()
      if (!isEmptyHtml(extra)) {
        parts.push('<p><strong>Anything else</strong></p>' + extra)
      }
      return parts.join('')
    },
    getEditorContent() {
      return this.$refs.descriptionEditor ? this.$refs.descriptionEditor.getContent() : '';
    },
    addQueryParameters() {
      this.$nextTick(() => {
        this.currentPage = this.$route.query.page
      });

      const created = this.filterValues.created || {}
      const votes = this.filterValues.vote_count || {}
      const watchers = this.filterValues.watcher_count || {}
      const newQuery = {
        ...this.$route.query,
        tab: this.activeTabIndex,
        count: this.perPage,
        page: this.currentPage,
        sort: this.sort.key,
        dir: this.sort.dir,
        key: this.filterValues.key,
        summary: this.filterValues.summary,
        reported_by: this.filterValues.reported_by,
        feature: this.filterValues.feature || '',
        ticket_type: this.filterValues.ticket_type || '',
        status: this.filterValues.status || '',
        priority: this.filterValues.priority || '',
        vote_count_to: votes.to || '',
        vote_count_from: votes.from || '',
        company_vote_only: this.filterValues.company_vote_only,
        created_to: created.to || '',
        created_from: created.from || '',
        watcher_count_to: watchers.to || '',
        watcher_count_from: watchers.from || ''
      }
      this.$router.replace({query: newQuery}).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          throw err;
        }
      });
    },
    getOffset(){
      return Math.max(0, Number((this.currentPage * this.perPage) - this.perPage))
    },
  },
  mounted(){
    this.restoreDraft()
    this.date_format_cal = this.date_format
    this.date_format_cal =  this.date_format_cal.replaceAll('Y', 'y')
    this.date_format_cal = this.date_format_cal.replaceAll('D', 'd')
    if(JSON.parse(localStorage.getItem('group')).show_day_of_week){
      this.day_of_week = 'ddd, '
    }
    // Default when the query omits count/page, otherwise Number(undefined) => NaN
    // would build a bad fetch URL / offset.
    this.perPage = Number(this.$route.query.count) || 10
    this.currentPage = Number(this.$route.query.page) || 1
    const sortKeys = this.sortOptions.map(o => o.key)
    if (sortKeys.includes(this.$route.query.sort)) {
      this.sort = { key: this.$route.query.sort, dir: this.$route.query.dir === 'desc' ? 'desc' : 'asc' }
    }
    this.loading = true
    // Seed FilterBar's flat values from the URL (select values are ids). FilterBar
    // resolves saved-views precedence and drives the first fetch via its initial
    // `change` (onFiltersChanged) — so we don't fetch here (except changelog-only).
    const q = this.$route.query || {}
    this.filterValues = {
      key: q.key || '',
      summary: q.summary || '',
      ticket_type: q.ticket_type ? Number(q.ticket_type) : '',
      feature: q.feature ? Number(q.feature) : '',
      reported_by: q.reported_by || '',
      created: { mode: 'range', days: '', from: q.created_from || '', to: q.created_to || '' },
      priority: q.priority ? Number(q.priority) : '',
      status: q.status ? Number(q.status) : '',
      vote_count: { from: q.vote_count_from || '', to: q.vote_count_to || '' },
      company_vote_only: q.company_vote_only === 'true',
      watcher_count: { from: q.watcher_count_from || '', to: q.watcher_count_to || '' }
    }

    if(!this.hasPermissions('roadmap_view')){
      // No filter bar in changelog-only mode; fetch directly.
      this.changelog_only = true
      this.getTickets(3, 1, 10000)
    } else {
      // Set the active tab from the URL WITHOUT fetching (FilterBar drives the first
      // fetch). Mirrors switchTab's tab-state bookkeeping minus the getTickets call.
      const tab = this.$route.query.hasOwnProperty('tab') ? Number(this.$route.query.tab) : 0
      this.dropHiddenSort(tab)
      this.activeTabIndex = tab
      for(let n in this.categories){
        this.categories[n].active = false
      }
      if(this.categories[tab]){
        this.categories[tab].active = true
      }
    }

  }
}
</script>

<style scoped>
/* Tabs header mirrors Campaigns: the hairline moves to the flex container so it
   spans past the action button; TabRail's own border goes transparent to avoid
   doubling. */
.tabs-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.tabs-header ::v-deep .tab-rail {
  border-bottom-color: transparent;
  min-width: 0;
}
.tabs-header__action {
  margin-top: 0;
  margin-bottom: 14px;
}
</style>

<style>
.white-content .tabs-header {
  border-bottom-color: rgba(0, 0, 0, 0.12);
}
</style>
